<template>
    <div class="wave-background d-flex justify-content-center align-items-center">
        <div class="login-sequence-box card"
            :class="[$breakpoint.xsOnly ? 'p-4' : 'p-5']"
        >
            <img :src="logoUrl" alt="Online Fuels Logo" class="d-block mb-5 logo" />
            <h1 class="heading-xlarge text-center mb-4">Reset your password</h1>
            <form v-if="!emailSent" @submit.prevent="sendEmail" class="w-100">
                <div class="form-group">
                    <label for="inputEmail">Enter your email address below</label>
                    <input id="email" class="w-100" v-model="user.email" @click="clearError" type="email" placeholder="Enter your email" required />
                </div>

                <button type="submit" class="btn btn-confirm float-right">Send password reset link</button>
            </form>
            <div v-else>
                <div class="success-message">An email with a password reset link has been sent to your email address</div>
            </div>
            <span class="error-message">{{error}}</span>
            <router-link id="back-to-login" to="/login">Go back to login page</router-link>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
const platform = process.env.VUE_APP_Platform ?? "DTN"

export default {
    mixins: [breakpoint],
    data() {
        return {
            logoUrl: `/assets/${platform}_Logo.png`,
            emailSent: false,
            user: {
                email: ''
            },
            error: '',
            response: ''
        }
    },
    methods: {
        validEmailChecker: function (email) {
            var checker = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return checker.test(email);
        },

        sendEmail: async function(event) {
            if (!this.validEmailChecker(this.user.email)) {
                this.error = 'Please enter a valid email address';
            }
            else {
                this.response  = this.axios.post('/api/requestNewPassword', this.user);
                this.response.catch(err=> {
                    if (err.response) {
                        this.error = err.response.data.message;
                    }
                });
                this.response.then((res) => {
                    if(res.data.success){
                        this.token = res.data.token;
                        this.emailSent = true;
                    }
                })
            }
            event.preventDefault();
        },

        clearError: function() {
            this.error = '';
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/_logins.scss";
</style>